<template>
  <el-busena :busena="aktasBusena" :color="busenaColor" />
</template>

<script>
export default {
  name: 'ElAktasBusena',
  props: {
    busena: String,
  },
  data() {
    return {
      busenaMap: {
        formuojama: 'Formuojama',
        suformuota: 'Suformuota',
        nesuformuota: 'Nesuformuota',
        laukia_patvirtinimo: 'Laukia patvirtinimo',
        laukia_ivykdymo: 'Laukia įvykdymo',
        vykdomas: 'Vykdomas',
        klaidingas: 'Klaidingas',
        ivykdytas: 'Įvykdytas',
      },
    }
  },
  computed: {
    aktasBusena() {
      return this.busenaMap[this.busena] ?? this.busena
    },
    busenaColor() {
      if (this.isBusenaIvykdytas || this.isBusenaSuformuota) {
        return 'green'
      }
      if (this.isBusenaKlaidingas) {
        return 'red'
      }
      if (this.isBusenaLaukiaPatvirtinimo) {
        return '#0a5c8e'
      }
      return 'default'
    },
    isBusenaKlaidingas() {
      return this.busena === 'klaidingas'
    },
    isBusenaIvykdytas() {
      return this.busena === 'ivykdytas'
    },
    isBusenaSuformuota() {
      return this.busena === 'suformuota'
    },
    isBusenaLaukiaPatvirtinimo() {
      return this.busena === 'laukia_patvirtinimo'
    },
  },
}
</script>
